import React, { FC } from 'react';
import TagManager from 'react-gtm-module';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import Link from '@buyside/components/presentation/Link/link';

import { proHome } from '@buyside/util/urlHelper';
import { ENV_VARS, verifyEnvVar } from '@env/usage';
import isLocalStorageNameSupported from '@buyside/util/isLocalStorageNameSupported';

const StripeSuccessPageRoot: FC<{ currentUserId: string }> = ({ currentUserId }) => {
  const stripePlan = isLocalStorageNameSupported()
    ? window.localStorage.getItem('stripePlan')
    : 'n/a';

  TagManager.initialize({
    auth: verifyEnvVar(ENV_VARS.GTM_AUTH),
    dataLayer: {
      event: 'Payment Success',
      page: 'subscribe',
      currentUserId,
      stripePlan
    },
    gtmId: 'GTM-5DKKZ3G',
    preview: verifyEnvVar(ENV_VARS.GTM_PREVIEW)
  });

  return (
    <ErrorBoundary pageName="payment success page">
      <div style={{ marginTop: '50px', textAlign: 'center' }}>
        <div style={{ fontWeight: '500', fontSize: '36px' }}>Thank you for your payment.</div>
        <div>Please click below if you are not redirected in 3 seconds.</div>
        <div>
          <Link to={proHome()}>Back to homepage</Link>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default StripeSuccessPageRoot;
